var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":_vm.label,"loading":_vm.isCompletudeRequired(_vm.bindAttribute, _vm.currentIssues)},model:{value:(_vm.valueAttribute),callback:function ($$v) {_vm.valueAttribute=$$v},expression:"valueAttribute"}})
}
var staticRenderFns = []

export { render, staticRenderFns }